"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToHilSignal = mapToHilSignal;
exports.mapFromHilSignal = mapFromHilSignal;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const differential_pair_mapper_js_1 = require("./differential-pair.mapper.js");
const signal_block_info_mapper_js_1 = require("./signal-block-info.mapper.js");
function mapToHilSignal(signal) {
    return {
        id: signal.id,
        name: signal.name,
        description: signal.description ?? null,
        isReviewed: false,
        attributes: (0, sigma_engine_shared_1.resolveSignalAttributes)(signal),
        direction: signal.signalDirection ?? null,
        sigmaModelSignal: signal.modelSignal ?? null,
        supportedDriveModes: signal.supportedDriveModes ?? [],
        blockInfo: signal.blockInfo === undefined ? null : (0, signal_block_info_mapper_js_1.mapToHilSignalBlockInfo)(signal.blockInfo),
        floatingBehavior: signal.floatingBehavior ?? null,
        ties: signal.ties ?? [],
        isCadstromInternal: signal.isCadstromInternal ?? false,
    };
}
function mapFromHilSignal(hilSignal, hilDifferentialPairs) {
    const diffPair = hilDifferentialPairs.find((pair) => pair.negativeSignalId === hilSignal.id || pair.positiveSignalId === hilSignal.id);
    return {
        name: hilSignal.name,
        padRefs: [],
        id: hilSignal.id,
        pinRefs: [],
        signalDirection: hilSignal.direction ?? undefined,
        attributes: {
            ...hilSignal.attributes,
        },
        description: hilSignal.description ?? undefined,
        modelSignal: hilSignal.sigmaModelSignal ?? undefined,
        diffPair: diffPair ? (0, differential_pair_mapper_js_1.mapFromHilDifferentialPair)(diffPair) : undefined,
        supportedDriveModes: hilSignal.supportedDriveModes,
        blockInfo: hilSignal.blockInfo === null ? undefined : (0, signal_block_info_mapper_js_1.mapFromHilSignalBlockInfo)(hilSignal.blockInfo),
        floatingBehavior: hilSignal.floatingBehavior ?? undefined,
        ties: hilSignal.ties,
        isCadstromInternal: hilSignal.isCadstromInternal,
    };
}
//# sourceMappingURL=signal.mapper.js.map